import { BoxProps } from '@chakra-ui/react';
import { LinkProps as RouterLinkProps } from 'react-router-dom';

import { CmFlex, CmLink } from '@/components/uiParts';

import { ChevronLeftIcon } from '../Icon';

type LinkProps = BoxProps & RouterLinkProps;
interface Props extends LinkProps {
  to: string;
}

export const CmBackLink = ({
  children,
  to,
  width,
  color,
}: Props): JSX.Element => {
  return (
    <CmFlex {...{ width }} alignItems="center">
      <CmLink width="max-content" color={color || 'blue.500'} {...{ to }}>
        <ChevronLeftIcon
          mt="-2px"
          height="6"
          width="6"
          color={color || 'blue.500'}
        />
        {children}
      </CmLink>
    </CmFlex>
  );
};
